import { render, staticRenderFns } from "./wait-ship-product.vue?vue&type=template&id=45185d05&"
import script from "./wait-ship-product.vue?vue&type=script&lang=js&"
export * from "./wait-ship-product.vue?vue&type=script&lang=js&"
import style0 from "./wait-ship-product.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports